import { Base64 } from 'base64-string';
import { IDecryptedKeys } from './decryptKeys';

export const setKeys = (userId: string, keys: IDecryptedKeys) => {
  const enc = new Base64();
  const serializedKeys = enc.encode(JSON.stringify(keys));

  localStorage.setItem(`${userId}.keys`, serializedKeys);
};
